'use client';

import { cn } from '@repo/utils/cn';
import { type ComponentProps } from 'react';
import { Link as NextLink } from '@/i18n/routing';

interface LinkProps extends ComponentProps<typeof NextLink> {
  className?: string;
}

/**
 * A styled link component that uses the Next.js Link component.
 */
const Link = ({ className, ...props }: LinkProps) => {
  return (
    <NextLink
      className={cn(
        'transition-colors duration-200 vt-atoms-link-text vt-text-size-smaller hover:vt-atoms-link-text-hover active:vt-atoms-link-text-active sm:vt-text-size-smaller-sm',
        className
      )}
      {...props}
    />
  );
};

/**
 * A un styled link component that uses the Next.js Link component.
 */
export const UnStyledLink = ({ className, ...props }: LinkProps) => {
  return (
    <NextLink
      className={cn(className)}
      {...props}
    />
  );
};

export default Link;
